<template>
  <v-card :loading="agency.loading"  elevation="0">
    <template v-if="agency && agency.result">
    <v-card-title class="py-6">
      <h1 class="font-weight-bold text-h2 basil--text">
        {{ agency.result.name }}
      </h1>
    </v-card-title>

    <v-tabs
      v-model="tab"
      right
    >
      <v-tab
        key="users"
      >
        Users
      </v-tab>
      <v-tab
        key="branches"
      >
        Branches
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        key="users"
      >
        <v-card
          flat
        >
          <v-card-text>
           <users report="users" view="company_users" :params="params" /> 
        </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        key="branches"
      >
        <v-card
          flat
        >
          <v-card-text>
            <branches report="branches" :params="params" />
        </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    </template>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const reportNamespace = createNamespacedHelpers("report");
const users = () => import("@/components/AdminComponent/user/list");
const branches = () =>
  import("@/components/AdminComponent/branch/list");

  export default {
    data () {
      return {
        params: {},
        tab: null,
        items: [
          'Appetizers', 'Entrees', 'Deserts', 'Cocktails',
        ],
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      }
    },
    computed: {
     ...reportNamespace.mapState({
      agency: (state) => state.agency,
    }),
    },
    components: {
      users,
      branches,
    },
    methods: {
      
    ...reportNamespace.mapActions(["getReport"]),
        
    },
    mounted() {
      this.params = {
        code: this.$route.params.code,
        company: this.$route.params.code,
      };

      this.getReport({
        report: 'agency',
        params: {
          code: this.$route.params.code,
        }
      })
    },
  }
</script>